import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Sanitise from '../../utilities/Sanitise';

function NotFound(props) {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('styleguide:notFound.title')}</h1>
      <Sanitise string={t('styleguide:notFound.body')} />
    </>
  );
}

NotFound.propTypes = {};

export default NotFound;
